import React, { useState } from 'react';

interface ImgProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  fallback?: React.ReactNode;
}

const Img: React.FC<ImgProps> = ({ src, alt, fallback, className, ...props }) => {
  const [error, setError] = useState(false);
  const [loaded, setLoaded] = useState(false);

  if (error && fallback) return <>{fallback}</>;

  return (
    <div className={`relative overflow-hidden ${className}`}>

      {!loaded && !error && (
        <div className="absolute inset-0 bg-gray-100 animate-pulse" />
      )}

      <img
        src={src}
        alt={alt}
        className={`${className} ${loaded ? 'opacity-100' : 'opacity-0'} transition-opacity duration-300`}
        onLoad={() => setLoaded(true)}
        onError={() => setError(true)}
        loading="lazy"
        decoding="async" //* Evita que a decodificação da imagem bloqueie a thread principal do navegador.
        {...props}
      />
    </div>
  );
};

export default Img;
